// const config = require('./config.json')

module.exports = {
    i18n: {
        defaultLocale: 'fa',
        locales: ['fa','en'],
        localeDetection: false,
    },
    serializeConfig: false,
    reloadOnPrerender: true,
    saveMissing: true,
    returnEmptyString: false,
    onPreInitI18next: (i18n) => {
        i18n.on('missingKey', (lngs, namespace, key) => {
            if (typeof window === 'undefined') return
            let trans = {}
            try {
                trans = JSON.parse(localStorage.getItem('missing_trans')) ?? {}
                // eslint-disable-next-line no-empty
            } finally {
            }
            for (const lng of lngs) {
                if (!trans[lng]) trans[lng] = {}
                if (namespace && !trans[lng][namespace])
                    trans[lng][namespace] = {}
                trans[lng][namespace][key] = ''
            }
            localStorage.setItem('missing_trans', JSON.stringify(trans))
        })
    }
}
